import { queryOptions, useMutation } from "@tanstack/react-query"

import { apiKey } from "@/lib/api/changes"
import { apiFetch } from "@/lib/api/client"
import type { ApiResource } from "@/lib/api/types"
import type {
  RequestScope,
  RequestSubject,
  SentRequests,
  Waiting,
  WaitingPerson,
} from "@/types/request"

export type RequestKind = "request" | "chase"

function subjectPath(subject: RequestSubject, kind: RequestKind): string {
  const base =
    subject.type === "firm"
      ? `/firms/${subject.id}`
      : `/individuals/${subject.id}`

  return kind === "request" ? `${base}/requests` : `${base}/chases`
}

export const requestQueries = {
  waiting: () =>
    queryOptions({
      queryKey: apiKey("/requests"),
      queryFn: async ({ signal }): Promise<Waiting> => {
        const { data, meta } = await apiFetch<{
          data: WaitingPerson[]
          meta: Pick<Waiting, "can">
        }>("/requests", { signal })

        return { people: data, can: meta.can }
      },
    }),
}

export function useSendAbout(subject: RequestSubject, kind: RequestKind) {
  return useMutation({
    mutationFn: async () => {
      const { data } = await apiFetch<ApiResource<SentRequests>>(
        subjectPath(subject, kind),
        { method: "POST" }
      )

      return data
    },
  })
}

export function useSendTo(kind: RequestKind) {
  return useMutation({
    mutationFn: async (scope: RequestScope) => {
      const { data } = await apiFetch<ApiResource<SentRequests>>(
        kind === "request" ? "/requests" : "/chases",
        { method: "POST", body: scope }
      )

      return data
    },
  })
}
